<template>
  <div>
    <!-- MODAL ZA  -->
    <b-modal v-model="modalShowCropCulture" centered hide-footer>
      <h5 align="center">{{this.$i18n.translate('SelectCulture')}}</h5>
      <br>
      <br>
      <div class="col-md-8 offset-md-2 text-center">
        <button
          type="button"
          class="btn btn-primary btn-lg"
          @click="modalShowCropCulture=!modalShowCropCulture"
        >{{this.$i18n.translate('OK')}}</button>
      </div>
      <br>
      <br>
    </b-modal>
    <div class="alert first-container-ePetro" role="alert">
      <transition-group name="fade" tag="div" class="form-row">
        <!-- CROP TYPE DROPDOWN -->

        <div :class="col_md" :key="1" class="fade-item">
          <label for="cropType_vv" class="col-form-label-sm font-weight-bold"
          >1. {{this.$i18n.translate('ChooseCultureGroup')}}</label>
          <template v-if="!loadIconCrops">
            <h1 align="center">
              <icon icon="spinner" pulse/>
            </h1>
          </template>
          <template v-else>
            <select class="form-control input-ePetro-select"
              :class="{'input': true, 'invalid-input': errors.has('cropType_vv') }"
              @change="getCropsByType()"
              v-validate="'required'"
              v-model.validate="cropType_vv"
              name="cropType_vv"
              id="cropType"
              v-model="pickedCropType">
              <option v-for="(cropType, index) in cropTypes" :key="index" :value="cropType.type"
                :data-imagesrc="cropType.imageSrc">{{cropType.name}}</option>
            </select>
          </template>
          <span v-show="errors.has('cropType_vv')" class="invalid">{{ errors.first('cropType_vv') }}</span>
        </div>
        <!-- CULTURE DROP DOWN -->
        <div v-bind:class="col_md" :key="2" class="fade-item">
          <label
            for="cropCultures_vv"
            class="col-form-label-sm font-weight-bold"
          >2. {{this.$i18n.translate('ChooseCulture')}}</label>
          <template v-if="!loadIconCrops">
            <h1 align="center">
              <icon icon="spinner" pulse/>
            </h1>
          </template>
          <template v-else>
            <select
              class="form-control input-ePetro-select"
              :class="{'input': true, 'invalid-input': errors.has('cropCultures_vv') }"
              id="cropCultures"
              @change="UpdateCropID"
              v-validate="'required'"
              v-model="cropCultures_vv"
              name="cropCultures_vv"
            >
              <option
                v-for="(crop, index) in cropSelectList"
                :key="index"
                :value="crop.id"
              >{{crop.name}}</option>
            </select>
          </template>
          <span
            v-show="errors.has('cropCultures_vv')"
            class="invalid"
          >{{ errors.first('cropCultures_vv') }}</span>
          <span
            v-show="customValCropId"
            class="invalid"
          >{{ !errors.first('cropCultures_vv') ? this.$i18n.translate('EntryCultureValue'):''}}</span>
        </div>
        <!-- STAGE DROPDOWN -->
        <div
          class="form-group col-md-4 fade-item"
          v-if="showCropStageShow"
          v-bind:class="{styleObject }"
          :key="3"
        >
          <label for="cropStage" class="col-form-label-sm font-weight-bold">3. {{this.$i18n.translate('ChoosePlantationStage')}}</label>
          <select class="form-control input-ePetro-select" :class="{'input': true, 'invalid-input': errors.has('cropStage_vv') }"
            id="cropStage"
            v-validate.initial="selectFruitValue ? 'required': ''"
            v-model.number="cropStage_vv"
            @change="UpdateCropStageID"
            name="cropStage_vv">
            <option v-for="(stage, index) in cropStageList" :key="index" :value="stage.id">{{stage.name}}</option>
          </select>
          <span v-show="errors.has('cropStage_vv')" class="invalid">{{ errors.first('cropStage_vv') }}</span>
        </div>
      </transition-group>
      <br>
      <br>
      <div class="form-row">
        <!-- EXPECTED YIELD -->
        <div class="col-md-3">
          <label
            for="yield_vv"
            class="col-form-label-sm font-weight-bold"
          >{{labelYield}}. {{this.$i18n.translate('ExpectedYield')}}</label>
          <input
            class="form-control input-ePetro"
            :class="{'input': true, 'invalid-input': errors.has('yield_vv') }"
            v-validate="validateFlag ?'required|decimal:3|min_value:0.001':''"
            id="yield_vv"
            name="yield_vv"
            :disabled="disableBtn"
            @input="UpdateYield"
            v-model.decimal="yield_vv"
            :placeholder="placeholder"
            autocomplete="off"
          >
          <span v-show="errors.has('yield_vv')" class="invalid">{{ errors.first('yield_vv') }}</span>
        </div>
        <!-- YIELD RADIO BTNS -->
        <div class="col-md-3">
          <div class="form-check radio-ePetro">
            <div class="custom-control custom-radio custom-control-inline mr-3">
              <input
                type="radio"
                class="custom-control-input"
                name="valueYieldRadio"
                id="valueYieldRadio_1"
                :value="radioYield_t"
                checked
                @click="UpdateYieldUnitId"
              >

              <label class="custom-control-label labelUnit" for="valueYieldRadio_1">t/ha</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                name="valueYieldRadio"
                id="valueYieldRadio_2"
                :value="radioYield_kg"
                @click="UpdateYieldUnitId"
              >
              <label class="custom-control-label labelUnit" for="valueYieldRadio_2">
                kg/m
                <sup>2</sup>
              </label>
            </div>
          </div>
        </div>
        <!-- SURFACE -->
        <div class="col-md-3">
          <label
            for="treatedSurface"
            class="col-form-label-sm font-weight-bold"
          >{{labelSurface}}. {{this.$i18n.translate('TotalCultivatedArea')}}</label>
          <input
            class="form-control input-ePetro"
            :class="{'input': true, 'invalid-input': errors.has('surface_vv') }"
            id="treatedSurface"
            name="surface_vv"
            @input="UpdateSurface"
            v-model.decimal="surface_vv"
            v-validate="'required|decimal:3|min_value:0.001'"
            :placeholder="placeholder"
            autocomplete="off"
          >
          <span v-show="errors.has('surface_vv')" class="invalid">{{ errors.first('surface_vv') }}</span>
        </div>

        <!-- SURFACE RADIO BTNS -->
        <div class="col-md-3">
          <div class="form-check radio-ePetro">
            <div class="custom-control custom-radio custom-control-inline mr-3">
              <input
                type="radio"
                class="custom-control-input"
                name="areaUnits"
                id="areaUnits_1"
                :value="radioSurface_h"
                @click="UpdateSurfaceUnitId"
                checked
              >
              <label class="custom-control-label labelUnit" for="areaUnits_1">ha&emsp;&nbsp;</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                name="areaUnits"
                id="areaUnits_2"
                :value="radioSurface_m"
                @click="UpdateSurfaceUnitId"
              >
              <label class="custom-control-label labelUnit" for="areaUnits_2">
                m
                <sup>2</sup>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import povrtna from "../assets/images/povrtna_kultura.png";
import ratarska from "../assets/images/ratarska_kultura.png";
import vocna from "../assets/images/vocna_kultura.png";

const GROUP_CULTURE = {
  FRUIT: 3
};

const NUMERIC_LABELS = {
  EXPECTED_YIELD: 4,
  TOTAL_AREA_CULTURE: 5,
  CHEMICAL_ANALYSIS_SOIL: 6
};
export default {
  data () {
    return {
      // If false hide select crop stage animation
      showCropStageShow: false,

      cropTypes: null,
      cropSelectList: null,
      cropStageList: null,
      crops: null,
      pickedCropType: null,
      cropStage: null,
      styleObject: {
        display: "none"
      },
      col_md: "form-group col-md-6",

      // radio buttons
      radioYield_t: null,
      radioYield_kg: null,
      radioSurface_h: null,
      radioSurface_m: null,

      // Flag for disable btn
      disableBtn: false,
      // Flag for validation (expected yield)
      validateFlag: true,

      // Validation for cropid
      customValCropId: false,

      // Flag for crop stage
      selectFruitValue: false,

      // Flag for select crops
      loadIconCrops: true,
      modalShowCropCulture: false,
      // dropDownSlick: true,

      // Vuex communication get/dispatch
      dispatch: this.$store.dispatch,
      get: this.$store.getters
    };
  },
  inject: ["$validator"],
  computed: {
    cropType_vv: {
      get () {
        return this.get.cropTypeValidation;
      },
      set (val) {
        this.dispatch("UpdateCropTypeValidation", val);
      }
    },
    cropCultures_vv: {
      get () {
        return this.get.cropCulturesValidation;
      },
      set (val) {
        this.dispatch("UpdateCropCulturesValidation", val);
      }
    },
    cropStage_vv: {
      get () {
        return this.get.cropStageValidation;
      },
      set (val) {
        this.dispatch("UpdateCropStageValidation", val);
      }
    },
    yield_vv: {
      get () {
        return this.get.yieldValidation;
      },
      set (val) {
        this.dispatch("UpdateYieldValidation", val);
      }
    },
    surface_vv: {
      get () {
        return this.get.surfaceValidation;
      },
      set (val) {
        this.dispatch("UpdateSurfaceValidation", val);
      }
    },
    // translations placeholder
    placeholder () {
      return this.$i18n.translate("PlaceHolderInput");
    },
    // Add label number for input parameters
    labelYield () {
      return this.get.labelYield;
    },
    labelSurface () {
      return this.get.labelSurface;
    },
    cropType () {
      return this.get._CROP_TYPES;
    }
  },
  watch: {
    cropType: function (val) {
      if (val.length > 0) {
        // remove & destroy ddslick if language is changed
        $("#cropType").ddslick("destroy");
        $("#cropType option").remove();

        // function for formatting ddslick data
        function ddSlickFormat (items) {
          if (items !== null && items !== undefined) {
            let ddslickData = [];
            items.forEach(function (element) {
              var ddslickItem = {
                text: element.name,
                value: element.type,
                imageSrc: element.imageSrc
              };
              ddslickData.push(ddslickItem);
            });
            return ddslickData;
          } else {
            return [];
          }
        }

        var funcPointerType = this.triggerCropsTypeChange;

        var formatedValue = ddSlickFormat(val);
        setTimeout(() => {
          $("#cropType").ddslick({
            data: formatedValue,
            selectText: " ",
            onSelected: function (data) {
              funcPointerType(data);
            }
          });
        }, 20);
      }
    }
  },
  methods: {
    loadPage: async function () {
      try {
        var cropTypesFinal = [];
        await this.$http.get(`cropType`).then(res => {
          res.data.data.forEach(function (element) {
            var tmpType = element;
            switch (element.type) {
              case 1:
                tmpType.imageSrc = ratarska;
                break;
              case 2:
                tmpType.imageSrc = povrtna;
                break;
              case 3:
                tmpType.imageSrc = vocna;
                break;
            }
            cropTypesFinal.push(tmpType);
          });

          this.cropTypes = cropTypesFinal;

          // Update initial data
          // this.$store.dispatch("UpdateShowInitialData", true);
        });

        // Get all units from db
        let radioButtonsUnits = await this.$http.get(`Unit`);
        // Isolate radio buttons group
        let result = radioButtonsUnits.data.data;

        // Prebaciti to u vuex i preko computed values pronalaziti id iz baze
        // Izraditi radio buttons pomoću v-for
        this.radioYield_t =
          result.findIndex(result => result.abbreviation === "t/ha") + 1;

        this.radioYield_kg =
          result.findIndex(result => result.abbreviation === "kg/m2") + 1;

        this.radioSurface_h =
          result.findIndex(result => result.abbreviation === "ha") + 1;

        this.radioSurface_m =
          result.findIndex(result => result.abbreviation === "m2") + 1;

        //Enable ddslick for culture dropdown
        this.initCropTypeDdSlick();

        //Func pointer because of this in jquery
        var funcPointerType = this.triggerCropsTypeChange;

        $("#cropType").ddslick({
          selectText: " ",
          onSelected: function (data) {
            funcPointerType(data);
          }
        });
      } catch (err) {
        window.alert(err);
        console.log(err);
      }
    },
    initCropTypeDdSlick: function (items) {
      var funcPointerCulture = this.triggerCropCultureChange;
      var ddslickData = this.formatDdslickData(items);

      //Destroy ddslick and cleanup select list
      $("#cropCultures").ddslick("destroy");
      $("#cropCultures option").remove();

      //Init ddslick
      $("#cropCultures").ddslick({
        data: ddslickData,
        selectText: " ",
        onSelected: function (data) {
          funcPointerCulture(data);
        }
      });

      //Set yield to default
      this.updateYieldAndSurface(null, null);
    },
    formatDdslickData: function (items) {
      if (items !== null && items !== undefined) {
        let ddslickData = [];
        items.forEach(function (element) {
          var ddslickItem = {
            text: element.name,
            value: element.id
          };
          ddslickData.push(ddslickItem);
        });
        return ddslickData;
      } else {
        return [];
      }
    },
    updateYieldAndSurface: function (yieldAmount, surfaceAmount) {
      this.yield_vv = yieldAmount;
      this.UpdateYield();
      this.surface_vv = surfaceAmount;
      this.UpdateSurface();
    },

    triggerCropCultureChange: function (data) {
      this.cropCultures_vv = String(data.selectedData.value);
      this.UpdateCropID();
    },

    triggerCropsTypeChange: function (data) {
      // dodati flag za loadicon
      this.loadIconCrops = true;

      console.log(data);
      this.pickedCropType = data.selectedData.value;
      this.cropType_vv = data.selectedData.value;
      this.getCropsByType();

      if (parseInt(data.selectedData.value) === GROUP_CULTURE.FRUIT) {
        // Conditional flag for crop stage validation
        this.selectFruitValue = true;

        // Add aditional flag (problems with ddslick) for validation cropStage

        // Set default value of crop stage to 1 (podizanje nasada)
        this.dispatch("UpdateCropStageID", 1);

        // Increment labels
        this.dispatch("UpdateLabelYield", NUMERIC_LABELS.EXPECTED_YIELD);
        this.dispatch("UpdateLabelSurface", NUMERIC_LABELS.TOTAL_AREA_CULTURE);
        this.dispatch("LabelAdditionalParameters", NUMERIC_LABELS.CHEMICAL_ANALYSIS_SOIL);

        // Change bootstrap columns from 6 to 4
        this.col_md = "form-group col-md-4";

        // Delay display the third div before first two div finish animation (showing cropstages dropdown)
        this.$nextTick(() => {
          setTimeout(() => {
            this.styleObject.display = "unset";
            this.getCropsStage();
            this.showCropStageShow = true;
          }, 500);
        });
      } else {
        // Change optional additional parameters to optional
        this.UpDateAdditionalValidation();

        this.selectFruitValue = false;

        // Decrament labels
        this.dispatch("UpdateLabelYield", NUMERIC_LABELS.EXPECTED_YIELD - 1);
        this.dispatch("UpdateLabelSurface", NUMERIC_LABELS.TOTAL_AREA_CULTURE - 1);
        this.dispatch("LabelAdditionalParameters", NUMERIC_LABELS.CHEMICAL_ANALYSIS_SOIL - 1);

        // Hide crop stage select option
        this.styleObject.display = "none";

        // Delay apply `md-6` to first two div before 3rd div finish animation (hidding cropstages dropdown)
        this.$nextTick(() => {
          setTimeout(() => {
            this.col_md = "form-group col-md-6";
          }, 1000);
        });
        this.showCropStageShow = false;
        this.cropStageList = null;

        // Reset values for crop stage list
        this.dispatch("UpdateCropStageID", this.cropStageList);

        // reset flag za loadicon
        this.loadIconCrops = false;
      }
    },
    getCropsByType: async function () {
      // If crop id is null then show error
      if (this.get.cropId == null || this.get.cropId) {
        this.customValCropId = true;
      }

      // If disable btn is true then deactivate it
      this.disableBtn = false;
      // If validation is false then activate it
      this.validateFlag = true;

      this.$http.get(`crop/Type/${this.pickedCropType}`).then(res => {
        // Add null value to prevent sending previous crop id
        this.dispatch("UpdateCropID", null);

        // Response data
        let responseCropsData = res.data.data;
        this.cropSelectList = responseCropsData;

        this.initCropTypeDdSlick(responseCropsData);

        // On change culture always restore values of additional parameters
        this.RestoreAdditionalValues();
      });
    },
    getCropsStage: async function () {
      // Get crops stage by name
      let responseCropsStage = await this.$http.get(`CropStage`);
      let responseCropsStageData = responseCropsStage.data.data;
      this.cropStageList = responseCropsStageData;

      var funcPointer = this.triggerCropStageChange;
      var ddslickData = this.formatDdslickData(responseCropsStageData);

      $("#cropStage").ddslick("destroy");
      $("#cropStage option").remove();

      //Init ddslick
      $("#cropStage").ddslick({
        data: ddslickData,
        selectText: " ",
        onSelected: function (data) {
          funcPointer(data);
        }
      });
    },

    triggerCropStageChange: function (data) {
      this.cropStage_vv = String(data.selectedData.value);
      this.UpdateCropStageID();
    },
    // Update Vuex store with inputed values
    UpdateCropID () {
      this.customValCropId = false;

      // Get crop stage value
      let cropStageId = parseInt(this.cropStage_vv);
      let ddslickData = $("#cropCultures").data("ddslick");
      let cropId = parseInt(ddslickData.selectedData.value);

      var crop = this.cropSelectList.find(x => {
        return x.id === cropId;
      });
      if (crop !== undefined && crop !== null) {
        // If cropstage is podizanje nasada (id=1) then never bind values to expected yield
        if (cropStageId === 1 && this.styleObject.display == "unset") {
          // update yield and surface
          this.updateYieldAndSurface(0, 1);

          // Update yield to 0
          this.dispatch("UpdateYield", 0);

          // Update crop id
          this.dispatch("UpdateCropID", parseInt(cropId) || null);
        } else {
          // console.log(crop);
          if (crop !== null && crop !== undefined) {
            this.updateYieldAndSurface(crop.averageYieldAmount, 1);
            this.dispatch("UpdateCropID", parseInt(cropId) || null);

            // Restore values of additional input
            this.RestoreAdditionalValues();
          }
        }
      }
    },
    UpdateCropStageID () {
      // Reset & remove values for additional parameters in store
      this.RestoreAdditionalValues();

      let cropStageId = parseInt(this.cropStage_vv);

      // If cropStageId is true then update required flag for additional parameters

      if (cropStageId === 1 && this.styleObject.display == "unset") {
        //this.dispatch("UpdateCropCulturesValidation", true);

        this.validateFlag = false;
        this.disableBtn = true;
        this.yield_vv = 0;

        // prepopulate yield with 0 value
        this.dispatch("UpdateYield", 0);

        // Change additional parameters to required
        this.dispatch("UpdateCropStageFruitValidation", true);
        // Open container with additional parameters
        this.dispatch("UpdateActiveDropDown", true);
        // Hide additonal yes/no buttons
        this.dispatch("UpdateDisableBtnAdditonal", true);
      } else {
        // Add flag for required culture id
        this.dispatch("UpdateCropCulturesValidation", false);

        // Change additional parameters to optional
        this.dispatch("UpdateCropStageFruitValidation", true);

        // Hide container with additional parameters
        this.dispatch("UpdateActiveDropDown", false);

        // Show additonal yes/no buttons
        this.dispatch("UpdateDisableBtnAdditonal", false);

        // Change additional parameters to optional
        this.UpDateAdditionalValidation();

        // else prepopulate/bind values of cultures to input expected yield
        let ddslickData = $("#cropCultures").data("ddslick");

        let cropId;
        // Check if ddslickData returns null
        if (ddslickData.selectedData == null) {
          // Show modal for selecting culture
          this.modalShowCropCulture = true;
        } else {
          // Save crop id
          this.modalShowCropCulture = false;
          cropId = parseInt(ddslickData.selectedData.value);
        }

        this.disableBtn = false;
        this.validateFlag = true;

        // find crop selected id
        var crop = this.cropSelectList.find(x => {
          return x.id === cropId;
        });

        if (crop !== null && crop !== undefined) {
          this.updateYieldAndSurface(crop.averageYieldAmount, 1);
          this.disableBtn = false;
        }
      }
      this.dispatch("UpdateCropStageID", parseInt(cropStageId) || null);
    },
    UpdateYield (e) {
      this.dispatch("UpdateYield", parseFloat(this.yield_vv) || null);
    },
    UpdateYieldUnitId (e) {
      this.dispatch("UpdateYieldUnitId", parseInt(e.target.value));
    },
    UpdateSurface (e) {
      this.dispatch("UpdateSurface", parseFloat(this.surface_vv) || null);
    },
    UpdateSurfaceUnitId (e) {
      this.dispatch("UpdateSurfaceUnitId", parseInt(e.target.value));
    },
    UpDateAdditionalValidation () {
      // Change additional parameters to optional
      this.dispatch("UpdateCropStageFruitValidation", false);
      this.dispatch("UpdateActiveDropDown", false);
      this.dispatch("UpdateDisableBtnAdditonal", false);
    },
    RestoreAdditionalValues () {
      // On change culture always restore values of additional parameters to default values
      this.dispatch("UpdateK2O", null);
      this.dispatch("UpdateP2O5", null);
      this.dispatch("UpdatepH", null);
      this.dispatch("UpdateHumus", null);
      this.dispatch("UpdateSoilTypeId", 2);

      // Reset style on btn click
      this.dispatch("UpdateAciveBtn", "btn2");
    }
  },
  created () {
    this.$nextTick(() => {
      this.loadPage();
    });
  }
};
</script>


<style scoped>
.invalid-input {
  border: 1px solid #f79483;
  box-shadow: 0 0 0 0.2rem #f7948340;
}

.invalid-input:focus {
  border: 1px solid #f79483;
  box-shadow: 0 0 0 0.2rem #f7948340;
}

.invalid {
  color: #f79483;
}

/* Animate dropdowns*/
.sample {
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  transition: all 0.2s;
}

.fade-item {
  transition: all 0.5s;
  display: inline-block;
}

.fade-enter {
  opacity: 0;
  transform: translateX(-130px);
}

.fade-enter-active {
  transition: all 1.5s;
}

.fade-leave-to {
  transform: translateX(130px);
  opacity: 0;
  flex: 0 0 20%;
}

.fade-leave-active {
  transition: all 1s;
}
</style>
